import React from "react";
import { Outlet } from "react-router-dom";
import BrandLogo from "../components/common/BrandLogo";
import { accountCaseFormContainerClasses } from "../components/common/caseListClasses";

const containerClasses = "content-wrapper min-h-screen! justify-center";
const innerWrapClasses = "max-w-[calc(var(--spacing)*137.5)] w-full mx-auto";
const logoClasses = "h-10 w-auto mx-auto mb-11";
// Bordered because the page canvas is now light, so a plain white card had no edge.
const formCardClasses = "bg-surface border border-border-light rounded p-6";

const Account = () => {
    return <>
        <div className={containerClasses}>
            <div className={innerWrapClasses} >
                <div className='text-center'>
                    <BrandLogo className={logoClasses} />
                </div>
                <div className={accountCaseFormContainerClasses}>
                    <div className={formCardClasses}>
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default Account;